var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 713,
    height: 627,
    viewBox: "0 0 713 627",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 471.948,
    width: 666.284,
    height: 217.934,
    transform: "rotate(-45 0 471.948)",
    fill: "#FDE68A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 458,
    y: 454,
    width: 74,
    height: 74,
    rx: 30,
    fill: "#A21CAF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 55,
    y: 159,
    width: 90,
    height: 90,
    rx: 30,
    fill: "#B45309"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 513,
    y: 46,
    width: 59,
    height: 60,
    rx: 29.5,
    fill: "#0369A1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 495,
    y: 375,
    width: 218,
    height: 218,
    rx: 50,
    fill: "#BE185D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoVideo);
export default __webpack_public_path__ + "static/media/deco-video.e515b75f8593f32d28b5b967873de8f3.svg";
export { ForwardRef as ReactComponent };